import * as React from 'react';
import Radio, { RadioProps } from '@mui/material/Radio';
import {RadioBtn, RadioBtnSelect} from "../../assets/icons/icons";
import './style.scss';

export default function RadioButton(props: RadioProps) {
  return (
    <Radio
      className="radio-button"
      disableRipple
      color="default"
      checkedIcon={<RadioBtnSelect />}
      icon={<RadioBtn />}
      {...props}
    />
  );
}
